export const DIGITAL_MENU = 'digitalMenu';
export const DIGITAL_MENU_URL = 'digitalMenuUrl';
export const SEND_MESSAGE_WHATS = 'sendMessageWhats';
